import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Compass, ArrowRight } from "@phosphor-icons/react";

const MyCoursesEmptyHero = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div
      className="relative overflow-hidden rounded-2xl mt-6 mb-10
        bg-gradient-to-br from-primary/20 via-grey to-bg
        border border-primary/30
        shadow-[0_0_40px_rgba(237,26,77,0.12)]
        p-8 md:p-12"
    >
      {/* Decorative blobs */}
      <div
        aria-hidden="true"
        className="absolute -top-20 -end-20 w-72 h-72 rounded-full bg-primary/20 blur-3xl pointer-events-none"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-24 -start-16 w-64 h-64 rounded-full bg-primary/10 blur-3xl pointer-events-none"
      />

      <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="max-w-xl">
          <div className="inline-flex items-center gap-1.5 bg-primary/25 border border-primary/50 px-3 py-1 rounded-full mb-3">
            <Compass size={14} className="text-primary" weight="fill" />
            <span className="text-[11px] font-bold uppercase tracking-wider text-primary">
              {t("my_courses.empty_hero_badge")}
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white leading-tight mb-3">
            {t("my_courses.empty_hero_title")}
          </h2>
          <p className="text-white/70 text-sm md:text-base">
            {t("my_courses.empty_hero_description")}
          </p>
        </div>

        <Link
          to="/categories"
          className="group inline-flex items-center justify-center gap-2
            bg-primary hover:bg-primary/90 text-white font-bold
            px-6 py-3.5 rounded-xl transition-all w-fit
            shadow-lg shadow-primary/30 whitespace-nowrap"
        >
          <span>{t("my_courses.empty_hero_cta")}</span>
          <ArrowRight
            size={18}
            weight="bold"
            className={`transition-transform group-hover:translate-x-1 ${
              isRTL ? "rotate-180 group-hover:-translate-x-1" : ""
            }`}
          />
        </Link>
      </div>
    </div>
  );
};

export default MyCoursesEmptyHero;
